import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import withAuth from "./HOC/withAuth";
import MainPage from "./pages/MainPage";
import LogIn from "./pages/LogIn";

import ToastPopup from "./components/ToastPopup";
import AlertsDialog from "./components/AlertsDialog";
import NotFound from "./pages/NotFound";
import MyPage from "./pages/MyPage";
import {RootState} from "./features/store";
import {useSelector} from "react-redux";
import {useEffect} from "react";
import {ThemeProvider as MuiThemeProvider, createMuiTheme} from "@material-ui/core/styles";
import {ThemeProvider as StyledThemeProvider} from "styled-components";
import {Theme} from "./theme";

function App() {
  const darkMode = useSelector((state: RootState) => state.theme.darkMode);
  console.log("⚾ ~ App ~ darkMode:", darkMode);
  const theme = Theme(darkMode);
  console.log("Current theme type:", theme.palette.type);
  sessionStorage.clear();

  return (
    <MuiThemeProvider theme={theme}>
      <StyledThemeProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate replace to="/inspect" />} />
            <Route path="/inspect/*" element={withAuth(MainPage, true)} />
            <Route path="/myPage" element={withAuth(MyPage, true)} />
            <Route path="/logIn" element={withAuth(LogIn, false)} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <ToastPopup />
          <AlertsDialog />
        </BrowserRouter>
      </StyledThemeProvider>
    </MuiThemeProvider>
  );
}

export default App;
